import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, Users, Sparkles } from 'lucide-react';
import WALink from './WALink';

const benefits = [
  { icon: Sparkles, text: "Nayi collections sabse pehle" },
  { icon: Users, text: "500+ like-minded women ka community" },
  { icon: MessageCircle, text: "Direct DM — seedha baat, bina kisi middleman ke" },
];

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] } }
};

export default function WhatsAppCTASection() {
  return (
    <section id="community" data-testid="footer-whatsapp" className="py-24 md:py-36 bg-[#2D4A2D] overflow-hidden relative">
      {/* Decorative pattern */}
      <div className="absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage: `radial-gradient(circle at 1px 1px, #C9A84C 1px, transparent 0)`,
          backgroundSize: '32px 32px',
        }}
      />
      <div className="absolute top-0 left-0 w-64 h-64 rounded-full bg-[#C9A84C]/5 -translate-x-1/2 -translate-y-1/2" />
      <div className="absolute bottom-0 right-0 w-96 h-96 rounded-full bg-[#C9A84C]/5 translate-x-1/3 translate-y-1/3" />

      <div className="relative z-10 max-w-4xl mx-auto px-6 md:px-12 text-center">
        <motion.span
          variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true }}
          className="inline-block text-xs md:text-sm font-sans uppercase tracking-[0.25em] text-[#C9A84C] font-medium mb-6"
        >
          Community Bulawa
        </motion.span>

        <motion.h2
          variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true }}
          transition={{ delay: 0.1 }}
          className="font-serif font-light text-[#F5F0E8] text-4xl md:text-5xl lg:text-6xl leading-[1.1] tracking-tight mb-6"
        >
          Join 500+ Women Who<br />
          <span className="italic text-[#C9A84C]">Chose Their Roots</span>
        </motion.h2>

        <motion.p
          variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          className="font-sans font-light text-[#F5F0E8]/75 text-base md:text-lg leading-relaxed mb-10 max-w-2xl mx-auto"
        >
          Yeh sirf ek WhatsApp group nahi — yeh ek movement hai. Modern women jo apni
          heritage celebrate karti hain, ek doosre ko support karti hain aur har din
          thoda aur confident hoti hain. Aa jaao!
        </motion.p>

        {/* Benefits */}
        <motion.div
          variants={{ hidden: { opacity: 0 }, visible: { opacity: 1, transition: { staggerChildren: 0.1, delayChildren: 0.3 } } }}
          initial="hidden" whileInView="visible" viewport={{ once: true }}
          className="flex flex-col sm:flex-row justify-center gap-6 mb-12"
        >
          {benefits.map(({ icon: Icon, text }) => (
            <motion.div
              key={text}
              variants={fadeUp}
              className="flex items-center gap-3 text-[#F5F0E8]/90"
            >
              <div className="w-8 h-8 border border-[#C9A84C]/40 flex items-center justify-center flex-shrink-0">
                <Icon size={16} strokeWidth={1.5} className="text-[#C9A84C]" />
              </div>
              <span className="font-sans font-light text-sm">{text}</span>
            </motion.div>
          ))}
        </motion.div>

        {/* CTA Button */}
        <motion.div
          variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true }}
          transition={{ delay: 0.4 }}
          className="flex flex-col sm:flex-row gap-4 justify-center"
        >
          <WALink
            source="whatsapp_cta_section"
            data-testid="whatsapp-join-btn"
            className="inline-flex items-center justify-center gap-3 bg-[#C9A84C] text-[#1A2A1A] px-10 py-5 font-sans font-semibold text-base tracking-wide transition-all duration-300 hover:bg-[#E8C96B] hover:scale-105 shadow-[0_4px_24px_rgba(201,168,76,0.3)]"
          >
            <MessageCircle size={22} strokeWidth={1.5} />
            Join Free — WhatsApp Community
          </WALink>
        </motion.div>

        <motion.p
          variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true }}
          transition={{ delay: 0.5 }}
          className="font-sans font-light text-[#F5F0E8]/75 text-sm mt-6 tracking-wide"
        >
          Free to join. No spam. Sirf authentic conversations.
        </motion.p>
      </div>
    </section>
  );
}
